import ApiService from "@/common/api/api.service";

let endpoint = "Projeto";

const Generico = {
    
    setEndpoint(endpointSelecionado) {
        endpoint = endpointSelecionado;
    },

    salvar(rubrica, form) {
        if(form.id)
            return ApiService.put(`${endpoint}/${rubrica}`, form)
        else
            return ApiService.post(`${endpoint}/${rubrica}`, form)
    },

    downloadArquivoCusto(custoId, arquivoTipo) {
        return ApiService.downloadFile(`${endpoint}/download-arquivo-custo?custoId=${custoId}&arquivoTipo=${arquivoTipo}`)
    },

    downloadArquivo(rubrica, arquivoId) {
        return ApiService.downloadFile(`${endpoint}/${rubrica}/download-arquivo?id=${arquivoId}`)
    },

    atualizar(rubrica, form) {
        return ApiService.put(`${endpoint}/${rubrica}`, form)
    },

    listar(rubrica,projetoId, nomeIdProjeto="ProjetoId", tamanhoDaPagina = 0, numeroDaPagina = 0) {
        return ApiService.get(`${endpoint}/${rubrica}?${nomeIdProjeto}=${projetoId}&TamanhoDaPagina=${tamanhoDaPagina}&NumeroDaPagina=${numeroDaPagina}`);
    },

    buscar(rubrica, id) {
        return ApiService.get(`${endpoint}/${rubrica}?id=${id}`);
    },

    deletar(rubrica, id) {
        let form = {
            id: id
        }
        return ApiService.delete(`${endpoint}/${rubrica}`, form);
    },

    deletarObj(rubrica, form) {
        return ApiService.delete(`${endpoint}/${rubrica}`, form);
    },
}

export default Generico;
